import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox8} from '../components';

class Dashboard8 extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox8/>
			</Fragment>
		);
	}
}

Dashboard8.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard8.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard8;